// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"cd3b2062","177":"46d2e3bd","213":"c770444d","426":"8ff651d8"}[chunkId] + ".chunk.js";
};